import PropertyByTabs from './PropertyByTabs';

export default PropertyByTabs;
